import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, ListGroup } from "react-bootstrap";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { useNavigate } from "react-router-dom";
import ApiUtils from "../../utils/api_utils";

const DiscountContent = (props) => {
  const navigate = useNavigate();

  const { reward_dashboard, initRewardPage, categoriesDiscount } = props;

  useEffect(() => {
    initRewardPage();
  }, []);

  return (
    <div>
      <Row className="discount-menu">
        {categoriesDiscount &&
          categoriesDiscount.map((item, index) => (
            <Col
              xs={3}
              sm={3}
              md={3}
              key={index}
              onClick={() => {
                navigate(PageRoutes.discountVoucher + "/" + item.slug);
              }}
            >
              <div className="menu-item">
                <img src={item.icon} className="menu-img" alt="menu_image" />
              </div>
              <div className="discount-menu-title">{item.name}</div>
            </Col>
          ))}
      </Row>
      <div className="latest-reward">
        <Row>
          <Col xs={9} sm={9} md={9} className="latest-reward-left">
            Latest Rewards
          </Col>
          <Col xs={3} sm={3} md={3} className="latest-reward-right">
            {/* See all */}
          </Col>
        </Row>
        <Row>
          <ListGroup>
            {Object.keys(reward_dashboard.latest).length
              ? reward_dashboard.latest.discount.map((d, index) => (
                  <ListGroup.Item key={`key-list-group${index}`}>
                    <Row>
                      <Col
                        xs={3}
                        sm={3}
                        md={3}
                        className="div-latest-discount-reward"
                      >
                        <img
                          src={ApiUtils.validateImgUrl({
                            url: d.thumbnail_img_url,
                          })}
                          className="latest-discount-reward-image"
                          alt="lr_image"
                        />
                      </Col>
                      <Col
                        xs={6}
                        sm={6}
                        md={6}
                        className="latest-discount-reward-detail"
                      >
                        <div className="latest-discount-reward-title">
                          {d.name}
                        </div>
                        <div className="latest-discount-reward-info">
                          <div
                            dangerouslySetInnerHTML={{ __html: d.description }}
                          />
                        </div>
                      </Col>
                      <Col
                        xs={3}
                        sm={3}
                        md={3}
                        className={
                          d.redeemable === false
                            ? "redeem-button-disabled"
                            : "redeem-button"
                        }
                      >
                        <Button
                          variant="danger"
                          className="btn-redeem"
                          disabled={d.redeemable === false ? true : false}
                          onClick={() => {
                            navigate(
                              `/reward/discount/${d.category.slug}/detail/${d.pk}`
                            );
                          }}
                        >
                          Redeem
                        </Button>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                ))
              : ""}
          </ListGroup>
        </Row>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  reward_dashboard: state.RewardSM.reward_dashboard,
  categoriesDiscount: state.RewardSM.categoriesDiscount,
});

const mapDispatchToProps = (dispatch) => ({
  initRewardPage: dispatch.RewardSM.initRewardPage,
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscountContent);
